/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VendorErrorParameter = {
    ParamUnknown: 'PARAM_UNKNOWN',
    Voltage: 'VOLTAGE',
    Current: 'CURRENT',
    PowerActive: 'POWER_ACTIVE',
    PowerReactive: 'POWER_REACTIVE',
    Energy: 'ENERGY',
    Frequency: 'FREQUENCY',
    Soc: 'SOC',
    Soh: 'SOH',
    Resistance: 'RESISTANCE',
    SignalStrength: 'SIGNAL_STRENGTH',
    Temperature: 'TEMPERATURE',
    Humidity: 'HUMIDITY',
    Pressure: 'PRESSURE',
    Co2: 'CO2',
    Voc: 'VOC',
    Illuminance: 'ILLUMINANCE',
    Vibration: 'VIBRATION',
    Acceleration: 'ACCELERATION',
    Velocity: 'VELOCITY',
    Latency: 'LATENCY',
    Torque: 'TORQUE',
    Force: 'FORCE',
    RotationalSpeed: 'ROTATIONAL_SPEED',
    FlowRate: 'FLOW_RATE',
    Volume: 'VOLUME',
    Level: 'LEVEL',
    Viscosity: 'VISCOSITY',
    Efficiency: 'EFFICIENCY',
    Usage: 'USAGE',
    Count: 'COUNT',
    DataRate: 'DATA_RATE',
    LogDebugMessage: 'LOG_DEBUG_MESSAGE'
} as const;
export type VendorErrorParameter = typeof VendorErrorParameter[keyof typeof VendorErrorParameter];


export function instanceOfVendorErrorParameter(value: any): boolean {
    for (const key in VendorErrorParameter) {
        if (Object.prototype.hasOwnProperty.call(VendorErrorParameter, key)) {
            if (VendorErrorParameter[key as keyof typeof VendorErrorParameter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorErrorParameterFromJSON(json: any): VendorErrorParameter {
    return VendorErrorParameterFromJSONTyped(json, false);
}

export function VendorErrorParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorParameter {
    return json as VendorErrorParameter;
}

export function VendorErrorParameterToJSON(value?: VendorErrorParameter | null): any {
    return value as any;
}

export function VendorErrorParameterToJSONTyped(value: any, ignoreDiscriminator: boolean): VendorErrorParameter {
    return value as VendorErrorParameter;
}

